<template>
  <div class="ui-filter-select">
    <label class="xs-title">{{ $attrs.name }}</label>
    <select>
      <slot></slot>
    </select>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.ui-filter-select {
}
</style>
